'use strict';

import template from './pay_conversation_modal.html';

export default {
  bindings: {
    done: '&',
    conversation: '<',
  },
  template: template,
};



// WEBPACK FOOTER //
// ./app/src/components/pay_conversation_modal/pay_conversation_modal.js